import { render, staticRenderFns } from "./StreakButtonWrapper.vue?vue&type=template&id=717db2ee&scoped=true&"
import script from "./StreakButtonWrapper.vue?vue&type=script&lang=ts&"
export * from "./StreakButtonWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./StreakButtonWrapper.vue?vue&type=style&index=0&id=717db2ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717db2ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('717db2ee', component.options)
    } else {
      api.reload('717db2ee', component.options)
    }
    module.hot.accept("./StreakButtonWrapper.vue?vue&type=template&id=717db2ee&scoped=true&", function () {
      api.rerender('717db2ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/StreakButtonWrapper.vue"
export default component.exports